"use client";
import React from "react";
import _styles from "./css/classes.module.css";
import * as _utils from "./webflow_modules/utils";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import { Spacer } from "./Spacer";

export function CaseStudyCardDevlink({
  buttonText = "Learn more",

  link = {
    href: "#",
  },

  resourceTag = "Whitepaper",
  thumbnail = "",
  title = "Heading",
}) {
  return (
    <Block className={_utils.cx(_styles, "case-study-card")} tag={"div"}>
      <Block
        className={_utils.cx(_styles, "case-study-card-thumbnail")}
        tag={"div"}
      >
        <Image
          className={_utils.cx(_styles, "cover-absolute-image")}
          height={"auto"}
          loading={"lazy"}
          src={thumbnail}
          width={"auto"}
        />
        <Block
          className={_utils.cx(_styles, "resource-card-tag-wrapper")}
          tag={"div"}
        >
          <Block
            className={_utils.cx(_styles, "resource-card-tag-light")}
            tag={"div"}
          >
            {resourceTag}
          </Block>
        </Block>
      </Block>
      <Spacer variant={"24"} />
      <Block className={_utils.cx(_styles, "case-study-card-text")} tag={"div"}>
        <Heading
          className={_utils.cx(_styles, "heading-style-h5")}
          fs-list-field={"name"}
          tag={"h3"}
        >
          {title}
        </Heading>
        <Spacer variant={"16"} />
      </Block>
      <Block className={_utils.cx(_styles, "case-study-bottom")} tag={"div"}>
        <Link
          block={"inline"}
          button={false}
          className={_utils.cx(_styles, "card-link")}
          fn-gap={"8"}
          options={link}
        >
          <Block className={_utils.cx(_styles, "weight-bold")} tag={"div"}>
            {buttonText}
          </Block>
          <HtmlEmbed
            content={
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" display="block">\n  <g clip-path="url(#clip0_6810_39884)">\n    <path d="M10.5003 10L6.66699 6.16667L7.83366 5L12.8337 10L7.83366 15L6.66699 13.8333L10.5003 10Z" fill="#191744" />\n  </g>\n  <defs>\n    <clipPath id="clip0_6810_39884">\n      <rect width="20" height="20" rx="10" fill="white" />\n    </clipPath>\n  </defs>\n</svg>'
            }
          />
        </Link>
      </Block>
    </Block>
  );
}
